const STORE_MODULES = require.context('@/store', false, /\.js$/);
const COMMON_STORE_MODULES = require.context('&/store', false, /\.js$/);
const store = STORE_MODULES.keys().reduce((store, PATH) => {
    if (PATH === './index.js') return store;
    const KEY = PATH.replace(/^\.\/(.*)\.\w+$/, '$1');
    store[KEY] = STORE_MODULES(PATH).default;
    return store;
}, {});
const commonStore = COMMON_STORE_MODULES.keys().reduce((store, PATH) => {
    if (PATH === './index.js') return store;
    const KEY = PATH.replace(/^\.\/(.*)\.\w+$/, '$1');
    store[KEY] = COMMON_STORE_MODULES(PATH).default;
    return store;
}, {});
const mergeStore = { ...commonStore, ...store };

export default mergeStore;
